﻿import jQuery from "jquery";

(function ($, kendo) {
    'use strict';

    var confirmTmpl = "";
    confirmTmpl += "<p class=\"message\">#= message #<\/p>";
    confirmTmpl += "<div class=\"confirmbottomtoolbar\"><button class=\"confirm k-button\">#= confirmText #<\/button> &nbsp;";
    confirmTmpl += "<button class=\"cancel k-button\">#= cancelText #<\/button></div>";

    function empty() {
    };

    var defaultConfig = {
        messages: [],
        title: 'Confirm',
        message: 'Are you sure?',
        confirmText: 'Yes',
        cancelText: 'No',
        confirm: empty,
        cancel: empty,
        showConfirm: true,
        showCancel: true
    };

    var defaultAlertConfig = {
        title: 'Alert',
        message: 'Alert!?',
        confirmText: 'Yes',
        cancelText: 'Ok',
        confirm: empty,
        cancel: empty,
        showConfirm: false,
        showCancel: true
    }

    var confirmWindow = {};

    var alertConfirmFcn = function(config) {
        // http://jsfiddle.net/gyoshev/HRcKK/
        var cw = $('<div></div>').kendoWindow({
            title: config.title,
            resizable: false,
            modal: true
        });

        var windowApi = cw.data('kendoWindow');

        // If we use the messages array, replace the actual content with the contents of the array
        if (config.messages && config.messages.length > 0) {
            config.message = config.messages.join('<br/>');
        }


        windowApi
            .content(kendo.template(confirmTmpl)(config))
            .center()
            .open();

        if (!config.showConfirm) {
            cw.find('.confirm').hide();
        }

        if (!config.showCancel) {
            cw.find('.cancel').hide();
        }

        cw.find('.confirm,.cancel').click(function (clickEvent) {
            clickEvent.preventDefault();

            if ($(this).hasClass('confirm')) {
                config.confirm();
            } else {
                config.cancel();
            }

            windowApi.close();
        });
    }


    confirmWindow.winxnetConfirmWindow = function (config) {
        config = $.extend({}, defaultConfig, config);
        alertConfirmFcn(config);

    };

    confirmWindow.winxnetAlertWindow = function(config) {
        config = $.extend({}, defaultAlertConfig, config);
        alert(config.message);
    }


    $.extend(confirmWindow);
})(jQuery, kendo);
